import type { Features } from 'models/features';
import { createContext } from 'react';

export const ToggleFeaturesContext = createContext<Nullable<Features>>(null);
ToggleFeaturesContext.displayName = 'ToggleFeaturesContext';
